<template>
    <div class="text-center">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="400"
            bottom left
            origin="top right"
            transition="scale-transition"
            offset-y>

            <template v-slot:activator="{ on }">
                <v-btn raised elevation="1" min-width="0" text v-on="on" @dblclick="onSubmit_Report">
                    <v-icon> mdi-arrow-down-thin-circle-outline</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="grey headline" style="color: white; font-size: 15px; font-weight: 500;">
                    <p class="pl-7 mb-5 mt-5">
                        Download: 'Vacations List'
                    </p>
                </v-card-title>

                <v-form ref="form" v-model="valid" lazy-validation style="background-color: #fff;">

                    <v-divider></v-divider>

                    <!-- >>> Field::Daterange -------------------------- -->
                    <v-list-item style="margin-top: 20px;">
                        <v-menu
                            ref="dates_dateMenuFlight"
                            v-model="datemenu_dateRange"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-combobox
                                    v-model="formattedDateRangeFlightSchedule"
                                    multiple
                                    class="sdr-custom-dates-combobox"
                                    chips
                                    v-bind="attrs"
                                    v-on="on"
                                    prepend-icon="mdi-calendar"
                                    :rules ="[
                                        rules.req(inputDateRange),
                                    ]"
                                    readonly>
                                    <template v-slot:label>
                                        Date Range <span style="color: red; font-size: 1.4rem;">*</span>
                                    </template>
                                </v-combobox>
                            </template>
                            <v-date-picker
                                v-model="inputDateRange"
                                :first-day-of-week="1"
                                no-title
                                range>
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="datemenu_dateRange = false">
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="onClick_datemenuFlightSchedule_OK">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-list-item>


                    <!-- >>> Buttons --------------------------------------- -->
                    <v-card-actions class="mt-4" style="background-color: #fff;">
                        <v-spacer></v-spacer>
                        <v-btn style="width:120px; font-size:12px;" class="mb-4" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
                        <v-btn style="width:120px; font-size:12px;" class="mb-4" depressed elevation="1" color="primary" @click="onSubmit_Report"> Download</v-btn>
                    </v-card-actions>

                </v-form>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        CONF_CALENDAR_DAYS_RANGE,
        CONF_SCHEDULER_TIME_RANGE_DAYS
    } from '../../../../config.js'
    import { mapActions, mapGetters } from 'vuex';
    import {  } from 'vuex';

    import dayjs from 'dayjs';
    import { eventBus } from '../../../../main';


    export default {
        name: 'DownloadMenue',

        /* >>> *************************************************************** / /* Data */
        data: () => ({
            // >>> ------------------------------
            menu: false,
            valid: false,

            // >>> ------------------------------ Filter:'Date Range' - 1.date from/to
            datemenu_dateRange: null,
            inputDateRange: [dayjs().format('YYYY-MM-DD'), dayjs().add(CONF_SCHEDULER_TIME_RANGE_DAYS, 'days').format('YYYY-MM-DD')],
            // >>> ------------------------------
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 3 || 'Min 3 characters',
                req(v) {
                    return (v || '').toString().length > 0 || `Field is required`;
                },
            },
        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Shared_AuthHeader',
            ]),


            /******************************************************************* 'DateFields Formatter'
            * formattedDateRangeFlightSchedule{}
            *
            * Desc:
            * Note:
            *
            */
            formattedDateRangeFlightSchedule: {

                get() {

                    let me = this;


                    me.$toc('>>> views/vacations/statusoverview/components/FilterMenue.vue >>> computed/formattedDateRangeFlightSchedule/get');
                    if (me.inputDateRange.length === 2) {
                        //switch dates, so the range is valid
                        if (dayjs(me.inputDateRange[0]).isAfter(dayjs(me.inputDateRange[1]))) {
                            //switch val[0] und val[1]
                            [me.inputDateRange[0], me.inputDateRange[1]] = [me.inputDateRange[1], me.inputDateRange[0]];
                        }
                    }


                    return me.inputDateRange ? [...new Set(me.inputDateRange.map((date) => me.formatDateForTextField(date)))].sort((a,b) => {return new Date(b.date) - new Date(a.date)}) : [];

                }, // eo function formattedDateRangeFlightSchedule get()


                set(value) {

                    let me = this;


                    me.$toc('>>> views/vacations/statusoverview/components/FilterMenue.vue >>> computed/formattedDateRangeFlightSchedule/set');
                    return me.inputDateRange = value;

                }, // eo function formattedDateRangeFlightSchedule set()

            }, // eo formattedDateRangeFlightSchedule{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
				// >>> --------------------------
				'actn_call_download_VacationReport',
            ]),


            /*******************************************************************
            * onSubmit_Report()
            *
            * Desc:
			* Note:
            *
            */
            onSubmit_Report: function() {

                const me = this;
                let params = {
                    fromDate: dayjs(me.inputDateRange[0]).format('YYYY-MM-DDT00:00:00'),
                    toDate: dayjs(me.inputDateRange[1]).format('YYYY-MM-DDT23:59:59')
                };

                me.$toc('>>> views/vacations/statusoverview/components/DownloadMenue.vue >>> onSubmit_Report');
                this.actn_call_download_VacationReport({ params: params, authheader: this.get_Shared_AuthHeader });

                this.menu = false; // close

            }, // eo function onSubmit_Report()


            /*******************************************************************
            * onClick_datemenuFlightSchedule_OK()
            *
            * Desc:
            * Note:
            *
            */
            onClick_datemenuFlightSchedule_OK: function(date) {

                let me = this;


                me.$toc('>>> views/vacations/statusoverview/components/FilterMenue.vue >>> onClick_datemenuFlightSchedule_OK');
                this.$refs.dates_dateMenuFlight.save(date);

            }, // eo function onClick_datemenuFlightSchedule_OK()


            /*******************************************************************
            * formatDateForTextField()
            *
            * Desc: Modify the date with the utc filter.
            * Note:
            *
            * @param {Object} date (date to format)
            */
            formatDateForTextField: function(date) {

                let me = this;


                me.$toc('>>> views/vacations/statusoverview/components/FilterMenue.vue >>> formatDateForTextField');
                return me.$options.filters.dayjsUtcDe(date, { showDayName: true });

            }, // eo function formatDateForTextField()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-text-field {
        padding-top: 5px !important;
    }

</style>

<style>
    /* */

    .v-application .headline {
        font-size: 20px !important;
    }



    /* */
    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }


    /* */
    .theme--light.v-input--is-disabled, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
        font-size: 14px;
        font-weight: 400;
        color: #495057;
    }


    /* */
    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
        text-transform: uppercase;
    }


    /* */
    .v-toolbar__content .v-btn--flat .v-icon {
        font-size: 25px;
        color: #555 !important;
        margin-top: -3px;
        top: 0;
        position: relative;
        margin-right: 0px;
    }


    /* Filter Menue Button*/
    .v-sheet .v-toolbar__content .v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab), .v-sheet .v-toolbar__content .v-btn.v-size--large:not(.v-btn--icon):not(.v-btn--fab) {
        margin-bottom: 0
    }

    .v-toolbar__content .v-btn--flat .v-icon {
        font-size: 20px;
    }


    /* Combobox need to be "readonly", but chips need to displayed "normal" */
    .sdr-custom-dates-combobox .v-chip--disabled {
        opacity: 1;
        color: rgba(0, 0, 0, 0.87) !important;
    }
</style>
